export const BaseURL = 'https://www.hbsqi.com'